"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/*eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */
var React = require("react");
var ReactDOM = require("react-dom");
var styles = require("./Modal.css");
require("./Modal.tablet.css");
require("./Modal.desktop.css");
var icons = require("./../../../styles/att-icons.css");
var OnEscape_1 = require("../../behaviors/OnEscape");
var Animate_1 = require("../../containers/Animate");
var ModalStylesMaps_1 = require("./ModalStylesMaps");
var utils_1 = require("../../../utils/utils");
var accessibility_1 = require("../../../utils/accessibility");
var endOfModal = 'End of Modal';
var queryString = "[tabindex]:not([disabled]):not([tabindex=\"-1\"]),\n a:not([disabled]),button:not([disabled]),\n textarea:not([disabled]),input:not([disabled]),\n iframe:not([disabled])";
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isModalVisible: false,
        };
        _this.modalParentClass = '';
        _this.modalMaskClass = '';
        _this.modalContentClass = '';
        _this.tabArray = [];
        _this.scrollPos = 0;
        if (typeof document !== 'undefined') {
            _this.el = document.createElement('div');
            _this.modalRoot = document.body;
        }
        _this.modalInlineStyles = {};
        _this.setModalRef = _this.setModalRef.bind(_this);
        // this.setFocus = this.setFocus.bind(this);
        _this.setModalVisibility = _this.setModalVisibility.bind(_this);
        _this.playAnimOnCollapse = _this.playAnimOnCollapse.bind(_this);
        _this.onCloseAnimComplete = _this.onCloseAnimComplete.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.setModalVisibility(false);
        _this.setDefaultClasses();
        _this.bindAll();
        return _this;
    }
    Modal.prototype.bindAll = function () {
        this.onModalVisible = this.onModalVisible.bind(this);
    };
    Modal.prototype.componentDidMount = function () {
        var _this = this;
        // this.el.setAttribute('aria-hidden', 'true');
        this.modalRoot.appendChild(this.el);
        this.modalRoot.addEventListener('click', function (e) {
            if (!_this.props.options.show) {
                _this.scrollPos = e.target.offsetTop - 50;
                _this.targetRef = e.target;
            }
        });
    };
    Modal.prototype.componentWillUnmount = function () {
        this.onModalClose();
        this.modalRoot.removeChild(this.el);
    };
    Modal.prototype.onModalVisible = function () {
        if (this.props.options && this.props.options.runOnModalVisible) {
            this.props.options.runOnModalVisible();
        }
    };
    Modal.prototype.setDefaultClasses = function () {
        if (this.props.options && this.props.options.className) {
            this.modalContentClass = this.props.options.className.modalContentClass;
            this.modalMaskClass = this.props.options.className.modalMaskClass;
            this.modalParentClass = this.props.options.className.modalParentClass;
        }
    };
    Modal.prototype.removeAccessibilityAttributes = function () {
        var i = 0;
        while (i < document.body.children.length) {
            if (!document.body.children[i].contains(this.modalRef)) {
                document.body.children[i].removeAttribute('aria-hidden');
            }
            i++;
        }
    };
    Modal.prototype.setAccessibilityAttributes = function () {
        var i = 0;
        while (i < document.body.children.length) {
            if (!document.body.children[i].contains(this.modalRef)) {
                document.body.children[i].setAttribute('aria-hidden', 'true');
            }
            i++;
        }
    };
    Modal.prototype.setModalVisibility = function (state) {
        var _this = this;
        this.setState({ isModalVisible: state }, function () {
            if (_this.state.isModalVisible === true) {
                _this.onModalVisible();
            }
        });
    };
    Modal.prototype.componentDidUpdate = function (prevProps) {
        if (typeof document === 'undefined') {
            return;
        }
        if (prevProps.options.show !== this.props.options.show) {
            if (!this.props.options.show) {
                this.onModalClose();
            }
            else {
                this.onModalOpen();
            }
        }
    };
    Modal.prototype.setModalRef = function (element) {
        this.modalRef = element;
        if (this.modalRef) {
            this.tabArray = this.modalRef.querySelectorAll(queryString);
        }
    };
    /* TDP-511795 fix
    setFocus() {
        if (this.modalRef) {
            this.tabArray = this.modalRef.querySelectorAll(queryString);
             const iframeIndex = this.index(this.tabArray, this.modalRef);
            if (iframeIndex > -1) {
               this.focusWhenReady(this.tabArray[iframeIndex]);
            } else {
                setTimeout(() => {
                    this.tabArray.length > 1 ? this.tabArray[0].focus() : this.tabArray[0].focus();
                }, 500);
            }
        }
    }
    */
    /* TDP-511795 fix
    focusWhenReady(iframeRef: any) {
        const iframe = iframeRef;
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        if (doc.readyState === 'complete') {
            iframe.contentWindow.focus();
        } else {
            this.tabArray[0].focus();
            setTimeout(this.focusWhenReady, 2000);
        }
    }
    */
    Modal.prototype.handleKeyDown = function (e) {
        // this.tabArray = this.modalRef.querySelectorAll(queryString);
        var iframeIndex = this.index(this.tabArray, this.modalRef);
        if (e.shiftKey === false && e.which === 9 &&
            (this.tabArray[this.tabArray.length - 1] === e.target)) {
            e.preventDefault();
            this.tabArray[0].focus();
        }
        else if ((e.shiftKey === false && e.which === 9 && iframeIndex > -1 &&
            (e.target === this.tabArray[iframeIndex - 1])) || (e.shiftKey && e.which === 9) && iframeIndex > -1
            && (this.tabArray[iframeIndex + 1] === e.target)) {
            e.preventDefault();
            this.tabArray[iframeIndex].focus();
        }
        else if ((e.shiftKey && e.which === 9) && (this.tabArray[0] === e.target)) {
            e.preventDefault();
            this.tabArray[this.tabArray.length - 1].focus();
        }
        else {
            return;
        }
    };
    Modal.prototype.index = function (elemArray, parent) {
        var i = 0;
        for (; i < elemArray.length; i++) {
            if (elemArray[i] === parent.querySelector('iframe')) {
                return i;
            }
        }
        return -1;
    };
    Modal.prototype.playAnimOnCollapse = function () {
        if (this.props.options && this.props.options.playAnimOnCollapse) {
            this.setModalVisibility(false);
        }
        else {
            if (this.props.events && this.props.events.onClose) {
                this.props.events.onClose();
            }
        }
    };
    Modal.prototype.onCloseAnimComplete = function () {
        if (this.props.events && this.props.events.onClose) {
            this.props.events.onClose();
        }
    };
    Modal.prototype.render = function () {
        if (!this.props.options.show) {
            return null;
        }
        return ReactDOM.createPortal(this.getModal(), this.el);
    };
    Modal.prototype.getModal = function () {
        return (React.createElement(OnEscape_1.default, { options: { disableEscape: this.props.options.disableEscape ? this.props.options.disableEscape : false }, events: { onEscaped: this.playAnimOnCollapse } },
            React.createElement(Animate_1.default, { options: {
                    collapseAnimType: 'FADE_OUT',
                    expandAnimType: 'FADE_IN',
                    isVisible: this.state.isModalVisible,
                    maintainStructure: true,
                    playAnimOnCollapse: this.playAnimOnCollapseExists,
                    playAnimOnExpand: this.playAnimOnExpandExists,
                } }, this.getMaskElement()),
            React.createElement(Animate_1.default, { options: {
                    affectChildNodes: false,
                    collapseAnimSettings: {
                        transformOrigin: 'MIDDLE_CENTER',
                    },
                    collapseAnimType: 'COLLAPSE',
                    expandAnimSettings: {
                        transformOrigin: 'MIDDLE_CENTER',
                    },
                    expandAnimType: 'EXPAND',
                    isVisible: this.state.isModalVisible,
                    maintainStructure: true,
                    playAnimOnCollapse: (this.props.options && this.props.options.playAnimOnCollapse) ?
                        this.props.options.playAnimOnCollapse : false,
                    playAnimOnExpand: (this.props.options && this.props.options.playAnimOnExpand) || false,
                }, events: {
                    onCollapseComplete: this.onCloseAnimComplete,
                } },
                React.createElement("div", { "data-test-id": this.props.testId, className: [styles.modalWrap, this.modalParentClass].join(' ') },
                    React.createElement("div", { className: this.getModalClasses(), style: this.modalInlineStyles },
                        React.createElement("div", { id: this.props.testId + '_modaldialogdesc', className: styles.modalEndDiv }, this.props.accessibilityText ? this.props.accessibilityText : this.props.testId),
                        React.createElement("div", __assign({}, this.getModalHeaderAttributes(), { className: [styles.modalContent, this.modalContentClass].join(' '), ref: this.setModalRef, onKeyDown: this.handleKeyDown }),
                            this.getModalHeaderDescElement(),
                            this.getCloseButtonElement(),
                            React.createElement("div", __assign({}, this.props.options ? accessibility_1.getAccessibilityAttributes(this.props.options) : {}), this.props.children),
                            React.createElement("div", { tabIndex: 0, title: endOfModal, className: styles.modalEndDiv }, endOfModal)))))));
    };
    Object.defineProperty(Modal.prototype, "playAnimOnCollapseExists", {
        // Getters
        get: function () {
            if (this.props.options && this.props.options.playAnimOnCollapse) {
                return this.props.options.playAnimOnCollapse;
            }
            else {
                return false;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Modal.prototype, "playAnimOnExpandExists", {
        get: function () {
            if (this.props.options && this.props.options.playAnimOnExpand) {
                return this.props.options.playAnimOnExpand;
            }
            else {
                return false;
            }
        },
        enumerable: false,
        configurable: true
    });
    Modal.prototype.getModalAccessibility = function () {
        return {
            'aria-labelledby': this.props.testId + '_modaldialogdesc',
            id: 'modalDialogdOnOpen',
        };
    };
    Modal.prototype.getModalClasses = function () {
        var modalClasses = [styles.modal, this.getSizeFromOps(this.props.options)];
        if (this.props.options.center) {
            modalClasses.push(styles.modalCentered);
        }
        return modalClasses.join(' ');
    };
    Modal.prototype.getMaskElement = function () {
        return (React.createElement("div", __assign({ tabIndex: -1, className: [styles.modalMask, this.modalMaskClass].join(' ') }, this.getModalAccessibility())));
    };
    Modal.prototype.getModalHeaderAttributes = function () {
        if (this.props.options && this.props.options.modalHeaderDesc) {
            return {
                id: this.props.testId + '_modaldialogdesc_hdrText',
                tabIndex: -1, role: 'dialog',
                'aria-modal': true, 'aria-labelledby': this.props.testId + '_modaldialogdesc',
            };
        }
    };
    Modal.prototype.getModalHeaderDescElement = function () {
        if (this.props.options && !this.props.options.modalHeaderDesc) {
            return (React.createElement("div", { id: this.props.testId + '_modaldialogdesc_hdrText', className: styles.modalHdng, tabIndex: -1, role: 'dialog', "aria-modal": true, "aria-labelledby": this.props.testId + '_modaldialogdesc' }, "\u00A0"));
        }
        return null;
    };
    ;
    Modal.prototype.getCloseButtonElement = function () {
        if (!this.props.options.showClose) {
            return null;
        }
        var isRedesign = this.props.options && this.props.options.isRedesign;
        return (React.createElement("button", { id: this.props.testId + '_Button_Close', "data-test-id": utils_1.default(this.props.testId, 'Button', 'Close'), className: isRedesign ? styles.modalCloseButtonRedesign : styles.modalCloseButton, onClick: this.playAnimOnCollapse, "aria-label": this.props.closeButtonAccessibiltiyText || 'Close' },
            React.createElement("i", { className: [icons.attIcon, icons.attIconClose, styles.modalCloseIcon].join(' ') })));
    };
    Modal.prototype.getSizeFromOps = function (options) {
        if (options.size) {
            return ModalStylesMaps_1.sizesMap.get(options.size);
        }
        return null;
    };
    Modal.prototype.onModalOpen = function () {
        this.setModalVisibility(true);
        var i = 0;
        var feedbackEl = document.getElementById('oo_tab');
        // this.modalRoot.setAttribute('aria-hidden', 'true');
        while (i < document.body.children.length) {
            // this.hdrElem = this.modalRoot.querySelector('h3#hdrText');
            this.hdrElem = this.modalRoot.querySelector('#' + this.props.testId + '_modaldialogdesc_hdrText');
            if (this.hdrElem && this.hdrElem !== undefined) {
                this.hdrElem.focus();
            }
            if (!document.body.children[i].contains(this.modalRef)) {
                document.body.children[i].setAttribute('aria-hidden', 'true');
                if (feedbackEl !== undefined && document.body.children[i].contains(feedbackEl)) {
                    document.body.children[i].removeAttribute('aria-hidden');
                }
            }
            i++;
        }
        this.modalRoot.parentElement.style.overflowY = 'hidden';
        this.modalRoot.parentElement.style.height = 'auto';
        this.modalRoot.style.overflowY = 'hidden';
        this.modalRoot.style.paddingRight = '17px';
        this.modalRoot.style.height = 'auto';
        // this.modalRoot.style.height = window.innerHeight + 'px';
        // this.modalRoot.style.position = 'fixed';
        // this.modalRoot.style.width = '100%';
        // this.modaldialogdesc = this.modalRoot.querySelector('#modalDialogdOnOpen');
        // this.modaldialogdesc.focus();
        // this.hdrElem = this.modalRoot.querySelector('h3#hdrText');
        if (this.props.options && this.props.options.focusFirstElement) {
            this.btnClose = this.modalRoot.querySelector('#' + this.props.testId + '_Button_Close');
            this.btnClose.focus();
        }
        else {
            this.hdrElem = this.modalRoot.querySelector('#' + this.props.testId + '_modaldialogdesc_hdrText');
            this.hdrElem.focus();
        }
    };
    Modal.prototype.onModalClose = function () {
        this.setModalVisibility(false);
        // this.modalRoot.setAttribute('aria-hidden', 'false');
        var i = 0;
        while (i < document.body.children.length) {
            if (!document.body.children[i].contains(this.modalRef)) {
                document.body.children[i].removeAttribute('aria-hidden');
            }
            i++;
        }
        this.modalRoot.parentElement.removeAttribute('style');
        this.modalRoot.removeAttribute('style');
        if (this.targetRef) {
            this.targetRef.focus();
        }
    };
    return Modal;
}(React.Component));
exports.default = Modal;
//# sourceMappingURL=Modal.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Modal/Modal.js
// module id = 332
// module chunks = 8